import { useTranslation } from 'react-i18next';
import { DrawTool } from '@agissc/ktag-map';
import useAppState from '../../../AppStore';

const useDrawTools = () => {
  const { t } = useTranslation('agisviewer');

  const activeDrawTool = useAppState((state) => state.activeDrawTool);
  const setActiveDrawTool = useAppState((state) => state.setActiveDrawTool);

  const handleClick = (drawTool: DrawTool) => {
    setActiveDrawTool(drawTool);
  };

  const toolOptions = [
    {
      label: t('draw_tool_line'),
      onClick: () => handleClick('line'),
      active: activeDrawTool === 'line',
      iconId: 'line-segment',
    },
    {
      label: t('draw_tool_dot'),
      onClick: () => handleClick('dot'),
      active: activeDrawTool === 'dot',
      iconId: 'dot-outline',
    },
    {
      label: t('draw_tool_polygon'),
      onClick: () => handleClick('polygon'),
      active: activeDrawTool === 'polygon',
      iconId: 'polygon',
    },
    {
      label: t('draw_tool_arrow'),
      onClick: () => handleClick('arrow'),
      active: activeDrawTool === 'arrow',
      iconId: 'internal',
    },
    {
      label: t('draw_tool_circle'),
      onClick: () => handleClick('circle'),
      active: activeDrawTool === 'circle',
      iconId: 'circle',
    },
    {
      label: t('draw_tool_text'),
      onClick: () => handleClick('text'),
      active: activeDrawTool === 'text',
      iconId: 'text-a',
    },
    {
      label: t('draw_tool_selection'),
      onClick: () => handleClick('selection'),
      active: activeDrawTool === 'selection',
      iconId: 'cursor',
    },
  ];

  return { toolOptions };
};

export default useDrawTools;
